import PropTypes from 'prop-types';
import { Dropdown, Pagination } from '@boozallen-uip/uswds-react-core';
import React from 'react';

const pageSizes = [
  {
    key: 20,
    value: '20 rows per page'
  },
  {
    key: 50,
    value: '50 rows per page'
  },
  {
    key: 100,
    value: '100 rows per page'
  }
];

export default function TableNavigation({ pageSize = 20, setPageSize = () => {}, totalPages = 0, setPage = () => {}, currentPage = 1}){
  const renderOption = ({ value }) => value;

  return (
    <div className="table-navigation flex items-center justify-between">
        <div>
          <style>{`
            .usa-label { margin-top: 0 }
            .usa-pagination { margin: 0 }
            .table-navigation .usa-select {
              appearance: none;
              -webkit-appearance: none;
              width: auto;
              min-width: 11rem;
              height: 2.75rem;
              margin-top: 0;
              border: 1px solid #565c65;
              border-radius: 0;
              padding: 0 2.25rem 0 0.75rem;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4 6l4 4 4-4' fill='none' stroke='%23565c65' stroke-width='2'/%3E%3C/svg%3E");
              background-repeat: no-repeat;
              background-position: right 0.7rem center;
              background-size: 0.7rem;
            }
          `}</style>
          <Dropdown
            id="pageSizePicker"
            optionRenderer={renderOption}
            options={pageSizes}
            value={pageSizes.find((option) => option.key === pageSize) || pageSizes[0]}
            showSelectOption={false}
            onChange={(e) => {
              setPageSize(e.detail.value.key);
            }
            }
          >
            <span className="usa-sr-only">Rows per page</span>
          </Dropdown>
        </div>
        <div className="">
          <Pagination page={currentPage} totalPages={totalPages} onChangePage={setPage} />
        </div>
      </div>
  )
}

TableNavigation.propTypes = {
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  totalPages: PropTypes.number,
  setPage: PropTypes.func,
  currentPage: PropTypes.number
}
